@if (_order) {
  @if (canUseCreditCards) {
    <div class="d-flex payment--selector align-self-center">
      <div class="me-4">
        <input
          class="radio-dark-gray me-2"
          name="{{ radioButtonName }}"
          type="radio"
          id="{{ accountButtonId }}"
          [(ngModel)]="paymentType"
          (change)="paymentTypeChanged()"
          value="account"
        />
        <label for="{{ accountButtonId }}">Pay On Account</label>
      </div>
      <div>
        <input
          class="radio-dark-gray me-2"
          name="{{ radioButtonName }}"
          type="radio"
          id="{{ creditCardButtonId }}"
          value="credit-card"
          [(ngModel)]="paymentType"
          (change)="paymentTypeChanged()"
        />
        <label for="{{ creditCardButtonId }}">Pay With Credit Card</label>
      </div>
    </div>
  } @else {
    <div class="d-flex">
      <label for="sapSearch">Payment Method:</label>
    </div>
  }
  <div>
    @if (paymentType === 'account') {
      <div class="sap--container">
        @if (canEditSAP) {
          <div
            class="sap__selector d-flex"
            [ngClass]="{ 'has-danger': isSapInvalid }"
            [class.mobile]="mobileDevice"
            [class.align-items-center]="!mobileDevice"
          >
            <ng-select
              [disabled]="performingUpdate"
              id="sapSearch"
              class="custom-select__sap"
              [items]="sapSearchResults"
              bindValue="id"
              placeholder="Search saved SAP"
              dropdownPosition="bottom"
              [searchable]="true"
              [loading]="sapSearchLoading"
              [typeahead]="sapSearchSubject"
              (change)="onSelectPaymentMethod($event)"
              [(ngModel)]="selectedCostCenterId"
              [clearable]="false"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.label }}
              </ng-template>
              <ng-template ng-header-tmp> Saved SAP Information </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.label }}</span>
              </ng-template>
            </ng-select>
            @if (canEditSAP && !performingUpdate) {
              <a
                class="link link-underline font-5 ms-2"
                (click)="addSap()"
                title="Add SAP"
                >Add SAP <i class="fas fa-plus"></i>
              </a>
            }
            @if (performingUpdate) {
              <div class="ms-2 fw-bold verify--container">
                <i class="fal fa-sync rotate"></i>&nbsp;
                @if (verifyingSAP) {
                  <span>Verifying...</span>
                }
                @if (updatingPaymentMethod) {
                  <span>Applying SAP...</span>
                }
              </div>
            }
          </div>
          @if (showDOA) {
            <div
              class="doa--container"
              [ngClass]="{ 'has-danger': isLimitExceeded }"
            >
              <label class="label">
                <span class="fw-bold">DOA Information</span>&nbsp;<span
                  class="font-6"
                  >(Required)</span
                >
              </label>
              <ng-select
                [disabled]="performingUpdate"
                id="employeeSearch"
                class="custom-select__sap"
                [items]="employeeSearchResults"
                bindValue="employee_id"
                [searchable]="true"
                placeholder="Please choose DOA"
                dropdownPosition="bottom"
                [typeahead]="employeeSearchSubject"
                (change)="onSelectEmployee($event)"
                [(ngModel)]="selectedEmployeeId"
                [clearable]="false"
              >
                <ng-template ng-label-tmp let-item="item">
                  <span>#{{ item.employee_id }} - {{ item.fullName }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span>#{{ item.employee_id }} - {{ item.fullName }}</span>
                </ng-template>
              </ng-select>
            </div>
          }
        }
      </div>
    } @else {
      <div>
        <div class="sap__selector" [class.mobile]="mobileDevice">
          <div>
            <ng-select
              [disabled]="performingUpdate"
              class="custom-select__sap"
              [items]="ccSearchResults"
              bindValue="id"
              placeholder="Search saved Credit Cards"
              dropdownPosition="bottom"
              [searchable]="true"
              [loading]="ccSearchLoading"
              [typeahead]="ccSearchSubject"
              (change)="onSelectPaymentMethod($event)"
              [(ngModel)]="selectedCreditCardId"
              [clearable]="false"
            >
              <ng-template ng-label-tmp let-item="item">
                <span [ngClass]="{ disabled: item.disabled }">{{
                  item.label
                }}</span>
              </ng-template>
              <ng-template ng-header-tmp>
                Saved Credit Cards Information
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div [ngClass]="{ disabled: item.disabled }">
                  <div>{{ item.label }}</div>
                  <div>XXXX-XXXX-XXXX-{{ item.last_four }}</div>
                </div>
              </ng-template>
            </ng-select>
            @if (isSaveCheckboxVisible) {
              <div class="mt-1">
                <input
                  type="checkbox"
                  id="saveCard"
                  [(ngModel)]="saveCard"
                  (change)="onSaveCreditCard()"
                />
                <label for="saveCard" class="ms-2"
                  >Save this card for future usage.</label
                >
              </div>
            }
          </div>
          @if (canAddCreditCard) {
            <a
              class="link link-underline font-5 ms-2"
              [class.align-self-center]="!mobileDevice"
              (click)="addCreditCard()"
              >Add Credit Card <i class="fas fa-plus"></i
            ></a>
          }
        </div>
        @if (
          selectedCreditCard?.type === 1 &&
          (!selectedCreditCard?.vendor ||
            selectedCreditCard?.vendor === paymentMethodVendor.Payeezy)
        ) {
          <p class="text-danger fw-bold">
            Action Required: Please re-upload your current card or enter a new
            card. Remove old cards under
            <a routerLink="/account/payment-methods">Payment Methods</a>, and
            re-upload for future use.
          </p>
        }
        @if (showCreditCardInfo) {
          <p class="m-0">
            <span class="fw-bold"
              >Your Card Will Not Be Charged Until Your Item Ships.</span
            ><br />
            <span class="font-5"
              >This May Result In Multiple Credit Card Transactions For A Single
              Order.</span
            >
          </p>
        }
      </div>
    }
  </div>
}
